export const TOKEN_KEY = 'token';
export const SIDEBAR_COLLAPSED = 'sidebar_collapsed';
export const AVATAR_BUBBLE = 'AVATAR_BUBBLE';
export const BUILDING_ONBOARDING = 'building_onboarding';
